import module from './module.js'
// Components
import './components/ingreso/masivo/component.js'
import './components/ingreso/masivo/confirmar/component.js'
import './components/ingreso/masivo/lista/component.js'
import './components/ingreso/masivo/lista/item/component.js'
// Routes
import './routes/ingreso/masivo.js'
// Services
import './services/ComprobanteIngreso/Emisor.js'
import './services/ComprobanteIngreso/Receptor.js'

export default module.name



// WEBPACK FOOTER //
// ./src/facturacion/facturas/index.js